import PageHeading from './PageHeading.svelte';

export default {
  component: PageHeading,
  name: 'Page Heading',
  inputs: [
    {
      name: 'title',
      type: 'string'
    },
    {
      name: 'description',
      type: 'richText'
    },
  ]
}
